import { render, staticRenderFns } from "./ShopDetailsModal.vue?vue&type=template&id=6a3e8e06"
import script from "./ShopDetailsModal.vue?vue&type=script&lang=js"
export * from "./ShopDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ShopDetailsModal.vue?vue&type=style&index=0&id=6a3e8e06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports